import { utility } from "..";

export const preReqs = (...args) => {
    let [dispatcher, navigator] = args;
    utility.dispatch = dispatcher();
    utility.navigate = navigator();
}